var map = {
	"./assessment/en/translations.json": [
		8308,
		[
			308
		]
	],
	"./assessment/es/translations.json": [
		83325,
		[
			325
		]
	],
	"./assessment/pt/translations.json": [
		55237,
		[
			237
		]
	],
	"./award/en/translations.json": [
		40653,
		[
			653
		]
	],
	"./award/es/translations.json": [
		4868,
		[
			868
		]
	],
	"./award/pt/translations.json": [
		37344,
		[
			344
		]
	],
	"./core/en/translations.json": [
		60125,
		[
			125
		]
	],
	"./core/es/translations.json": [
		37524,
		[
			524
		]
	],
	"./core/pt/translations.json": [
		54992,
		[
			992
		]
	],
	"./dashboard/en/translations.json": [
		90912,
		[
			912
		]
	],
	"./dashboard/es/translations.json": [
		58449,
		[
			830
		]
	],
	"./dashboard/pt/translations.json": [
		80553,
		[
			553
		]
	],
	"./knowledge/en/translations.json": [
		44856,
		[
			856
		]
	],
	"./knowledge/es/translations.json": [
		17049,
		[
			49
		]
	],
	"./knowledge/pt/translations.json": [
		81009,
		[
			9
		]
	],
	"./lms/en/translations.json": [
		48800,
		[
			800
		]
	],
	"./lms/es/translations.json": [
		38449,
		[
			449
		]
	],
	"./lms/pt/translations.json": [
		585,
		[
			585
		]
	],
	"./shared/en/translations.json": [
		56155,
		[
			536
		]
	],
	"./shared/es/translations.json": [
		32498,
		[
			498
		]
	],
	"./shared/pt/translations.json": [
		27386,
		[
			386
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 38083;
module.exports = webpackAsyncContext;